import React from 'react';

import { ActionPanel } from '../action/ActionPanel';
import { DeleteAction } from '../action/DeleteAction';
import PipeOperations from '../pipe-operations';

import type { Pipe } from '../../types/pipes.types';
import type { System } from '../../types/system.types';
import type { Dataset } from '../../types/dataset.types';

export const ListActions: React.FC<{
  onDelete: () => void;
  selection?: Pipe[] | System[] | Dataset[];
  name: string;
}> = ({ selection, onDelete, name }) => (
  <div className="list-actions">
    <ActionPanel>
      {selection && <PipeOperations pipes={selection as never} />}
      <DeleteAction title={name} selection={selection ?? []} onDelete={onDelete} />
    </ActionPanel>
  </div>
);
